/**
 * Sets up the mobile navigation functionality
 */
export function setupMobileNav() {
    const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
    const nav = document.querySelector('.nav');
    
    if (!mobileNavToggle || !nav) return;
    
    // Check if we're on mobile based on media query
    // NOTE: 768px must match the $mobile breakpoint in _variables.scss
    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
    
    // Function to update navigation visibility based on screen size
    const updateNavVisibility = () => {
        if (isMobile()) {
            // On mobile: hide by default, unless it has the 'show' class
            if (!nav.classList.contains('show')) {
                nav.style.display = 'none';
            }
        } else {
            // On desktop: always visible, reset styles
            nav.style.display = '';
            nav.classList.remove('show');
        }
    };
    
    // Initial setup
    updateNavVisibility();
    
    // Update on window resize
    window.addEventListener('resize', updateNavVisibility);
    
    // Toggle navigation when button is clicked
    mobileNavToggle.addEventListener('click', () => {
        if (nav.classList.contains('show')) {
            nav.classList.remove('show');
            mobileNavToggle.setAttribute('aria-expanded', 'false');
            // Add a small delay before hiding to allow for transition
            setTimeout(() => {
                if (isMobile()) nav.style.display = 'none';
            }, 300);
        } else {
            nav.style.display = 'flex';
            // Small delay to ensure display is applied before adding class
            setTimeout(() => {
                nav.classList.add('show');
                mobileNavToggle.setAttribute('aria-expanded', 'true');
            }, 10);
        }
    });
    
    // Close navigation when a link is clicked
    const navLinks = nav.querySelectorAll('a');
    navLinks.forEach(link => {
        link.addEventListener('click', () => {
            if (isMobile()) {
                nav.classList.remove('show');
                mobileNavToggle.setAttribute('aria-expanded', 'false');
                setTimeout(() => {
                    nav.style.display = 'none';
                }, 300);
            }
        });
    });

    // Close navigation when clicking outside
    document.addEventListener('click', (event) => {
        if (!nav.contains(event.target) &&
            !mobileNavToggle.contains(event.target) &&
            nav.classList.contains('show') &&
            isMobile()) {

            nav.classList.remove('show');
            mobileNavToggle.setAttribute('aria-expanded', 'false');
            setTimeout(() => {
                nav.style.display = 'none';
            }, 300);
        }
    });
} 